import React, { FC } from 'react'
import { Add, HighlightOff } from '@mui/icons-material'

interface AddFileProps {
  type: 'image' | 'file' | 'video'
  onClick: (fileUrl?: string) => void
  data: string[]
  placeholder: string
}

export const AddFile: FC<AddFileProps> = ({ type, onClick, data, placeholder }) => {
  return (
    <div className="min-h-[50px] image-upload-preview-container flex bg-SeabiscuitGrayThemeColor p-2 rounded-xl w-full items-center">
      <div className="flex items-center flex-wrap gap-1">
        {data?.[0]
          ? data.map((currFile, index) => {
              return (
                !!currFile && (
                  <div key={index} className="imageThumbnail">
                    <div className="image-preview relative rounded-md w-[34px] h-[34px] overflow-hidden z-[0] border border-border">
                      <img
                        src={
                          type === 'video'
                            ? '/assets/placeholders/video.svg'
                            : type === 'file'
                              ? '/assets/img/pdf.png'
                              : currFile
                        }
                        alt=""
                        className="image shrink-0 object-cover w-full h-full"
                      />
                      <button
                        type="button"
                        onClick={() => onClick(currFile)}
                        className="absolute w-full h-full left-0 top-0 opacity-0 cursor-pointer hover:opacity-100 z-[1] transition-all"
                      >
                        <HighlightOff className="text-SeabiscuitMainThemeColor" />
                      </button>
                    </div>
                  </div>
                )
              )
            })
          : null}
      </div>
      <div
        className="relative flex-1 h-[26px] flex items-center justify-center pl-1 pr-3 cursor-pointer"
        onClick={() => onClick()}
      >
        <div className="text-[#8590a1] text-[14px] text-center">{placeholder}</div>
        <Add
          fontSize="medium"
          className="absolute top-[-18px] right-[-18px] cursor-pointer border border-SeabiscuitDark200ThemeColor rounded-full text-SeabiscuitDark200ThemeColor bg-SeabiscuitWhiteThemeColor"
        />
      </div>
    </div>
  )
}
